export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повторить операцию"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["История операций"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Список счетов"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неизвестная ошибка"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Список токенов"])}
}